import { sb } from '../../supabase.ts';
import { escapeHtml } from '../../main.ts';

export async function renderOtherSchoolDatabasePage(app: HTMLElement): Promise<void> {
  const tableName = 'student_database_others';
  const loggedInSchool = localStorage.getItem('adminButton');
  const { data: { session } } = await sb.auth.getSession();
  const isSupabaseUser = !!session && !loggedInSchool;

  if (!isSupabaseUser && !loggedInSchool) {
    window.location.href = '/other_school/login';
    return;
  }

  const currentUser = loggedInSchool || 'admin';

  app.innerHTML = `
    <style>
      .db-wrap {
        background: radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.04), transparent 45%), linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        color: #334155;
        font-family: 'Outfit', 'Segoe UI', sans-serif;
        min-height: 100vh;
        padding-bottom: 40px;
      }
      .db-header {
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding: 14px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .db-header h1 {
        font-size: 20px;
        margin: 0;
        font-weight: 850;
        color: #0f172a;
      }
      .back-btn {
        color: #10b981;
        text-decoration: none;
        margin-right: 12px;
        font-size: 20px;
        font-weight: bold;
        transition: transform 0.2s;
        display: inline-block;
      }
      .back-btn:hover {
        transform: translateX(-3px);
      }
      .db-container {
        padding: 24px;
        max-width: 100%;
        box-sizing: border-box;
      }
      .toolbar {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: center;
        margin-bottom: 20px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        padding: 16px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.02);
      }
      .filter-pair {
        display: flex;
        gap: 8px;
        align-items: center;
      }
      .filter-label {
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        color: #64748b;
        letter-spacing: 0.5px;
      }
      .filter-select {
        padding: 8px 12px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 6px;
        font-size: 14px;
        color: #0f172a;
        cursor: pointer;
        outline: none;
        min-width: 120px;
        transition: border-color 0.2s;
      }
      .filter-select:focus {
        border-color: #10b981;
      }
      .toolbar button {
        padding: 8px 16px;
        background: linear-gradient(135deg, #10b981, #059669);
        border: none;
        border-radius: 6px;
        color: #ffffff;
        font-weight: 700;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .toolbar button:hover {
        opacity: 0.95;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
      }
      .toolbar button.outline {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        color: #475569;
      }
      .toolbar button.outline:hover {
        background: #f8fafc;
        border-color: rgba(0, 0, 0, 0.2);
        color: #0f172a;
      }
      .status {
        font-size: 13px;
        color: #64748b;
      }
      .table-wrap {
        overflow-x: auto;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        background: #ffffff;
        box-shadow: 0 8px 24px rgba(0,0,0,0.02);
      }
      table {
        width: 100%;
        border-collapse: collapse;
        font-size: 15px;
      }
      th, td {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        padding: 12px 14px;
        text-align: left;
        color: #334155;
      }
      th {
        font-weight: 700;
        font-size: 13.5px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        background: rgba(248, 250, 252, 0.95);
        color: #64748b;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      }
      tbody tr {
        transition: background-color 0.2s;
      }
      tbody tr:hover {
        background: rgba(0, 0, 0, 0.01) !important;
      }
      .col-sl {
        width: 52px;
        text-align: center;
      }
      .row-thumb {
        width: 44px;
        height: 54px;
        object-fit: cover;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.08);
        background: #f1f5f9;
        cursor: pointer;
        transition: transform 0.2s;
      }
      .row-thumb:hover {
        transform: scale(1.08);
      }
      .btn {
        padding: 6px 12px;
        font-size: 12px;
        border-radius: 6px;
        font-weight: 600;
        cursor: pointer;
        border: none;
        transition: all 0.2s;
        text-decoration: none;
        display: inline-block;
      }
      .btn.edit {
        background: #f59e0b;
        color: #ffffff;
        font-weight: 700;
      }
      .btn.edit:hover {
        background: #d97706;
      }
      .btn.view {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        color: #475569;
      }
      .btn.view:hover {
        background: #f8fafc;
        border-color: rgba(0, 0, 0, 0.2);
        color: #0f172a;
      }
      .action-cell {
        display: flex;
        gap: 8px;
      }
      .row-fulldata-ok {
        background: rgba(16, 185, 129, 0.04) !important;
      }
      .status-tc {
        background: rgba(239, 68, 68, 0.04) !important;
      }
      #photo-preview {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 12px;
        padding: 12px;
        box-shadow: 0 20px 50px rgba(15, 23, 42, 0.12);
        z-index: 10001;
        display: none;
        pointer-events: none;
      }
      #photo-preview img {
        max-width: 320px;
        max-height: 400px;
        display: block;
        object-fit: contain;
        border-radius: 6px;
      }
    </style>

    <div class="db-wrap">
      <header class="db-header">
        <div style="display: flex; align-items: center;">
          <a href="/other_school_dashboard" class="back-btn">⬅</a>
          <h1 id="headerTitle">Student Database — Other School</h1>
        </div>
      </header>

      <div class="db-container">
        <div class="toolbar">
          <div class="filter-pair" id="schoolFilterWrap" style="display: none;">
            <label for="schoolFilter" class="filter-label">School</label>
            <select id="schoolFilter" class="filter-select">
              <option value="">All Schools</option>
            </select>
          </div>
          <div class="filter-pair">
            <label for="sessionFilter" class="filter-label">Session</label>
            <select id="sessionFilter" class="filter-select"></select>
          </div>
          <div class="filter-pair">
            <label for="classFilter" class="filter-label">Class</label>
            <select id="classFilter" class="filter-select"></select>
          </div>
          <div class="filter-pair">
            <label for="sectionFilter" class="filter-label">Section</label>
            <select id="sectionFilter" class="filter-select"></select>
          </div>
          
          <div style="display: flex; gap: 12px; align-items: center; margin-left: auto;">
            <button id="refreshBtn">Refresh</button>
            <button id="clearFilters" class="outline">Clear</button>
            <span id="status" class="status"></span>
          </div>
        </div>

        <div style="margin-bottom: 12px; color: #64748b; font-size: 13px;" id="sessionInfo"></div>

        <div class="table-wrap">
          <table id="dataTable">
            <thead>
              <tr>
                <th class="col-sl">SL</th>
                <th>IID</th>
                <th>Class</th>
                <th>Section</th>
                <th>Roll</th>
                <th>Name</th>
                <th>Father Name</th>
                <th>Father Mobile</th>
                <th>Photo</th>
                <th>Session</th>
                <th>Status</th>
                <th>FullData</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr><td colspan="13">Loading...</td></tr>
            </tbody>
          </table>
        </div>
        <div id="rowCount" style="margin-top: 12px; font-size: 13px; color: #64748b;"></div>
      </div>
    </div>

    <div id="photo-preview"><img src="" alt="preview"/></div>
  `;

  const tbody = document.querySelector('#dataTable tbody') as HTMLElement;
  const statusEl = document.getElementById('status') as HTMLElement;
  const schoolFilterWrap = document.getElementById('schoolFilterWrap') as HTMLDivElement;
  const schoolFilter = document.getElementById('schoolFilter') as HTMLSelectElement;
  const sessionFilter = document.getElementById('sessionFilter') as HTMLSelectElement;
  const classFilter = document.getElementById('classFilter') as HTMLSelectElement;
  const sectionFilter = document.getElementById('sectionFilter') as HTMLSelectElement;
  const refreshBtn = document.getElementById('refreshBtn') as HTMLButtonElement;
  const clearFilters = document.getElementById('clearFilters') as HTMLButtonElement;
  const sessionInfo = document.getElementById('sessionInfo') as HTMLElement;
  const rowCountEl = document.getElementById('rowCount') as HTMLElement;
  const headerTitle = document.getElementById('headerTitle') as HTMLElement;

  if (isSupabaseUser) {
    headerTitle.textContent = `Student List — Super Admin`;
    schoolFilterWrap.style.display = 'flex';
  } else if (loggedInSchool) {
    headerTitle.textContent = `Student List — ${loggedInSchool}`;
  } else {
    headerTitle.textContent = `Student List — Guest`;
  }

  // Preview elements
  const previewEl = document.getElementById('photo-preview') as HTMLDivElement;
  const previewImg = previewEl.querySelector('img') as HTMLImageElement;
  let previewTimeout: any;

  // Delegate hover photo preview
  document.addEventListener('mouseenter', (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if (target && target.classList && target.classList.contains('row-thumb')) {
      clearTimeout(previewTimeout);
      const img = target as HTMLImageElement;
      previewImg.onload = () => { previewEl.style.display = 'block'; };
      previewImg.onerror = () => { previewEl.style.display = 'none'; };
      previewImg.src = img.src;
    }
  }, true);

  document.addEventListener('mouseleave', (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if (target && target.classList && target.classList.contains('row-thumb')) {
      clearTimeout(previewTimeout);
      previewTimeout = setTimeout(() => { previewEl.style.display = 'none'; }, 100);
    }
  }, true);

  let allRowsCache: any[] = [];
  let existingSessionCols = {
    classes: new Set<string>(),
    sections: new Set<string>(),
    rolls: new Set<string>()
  };

  // 1. Column discovery
  async function discoverSessionColumns() {
    try {
      const { data, error } = await sb.from(tableName).select('*').limit(1);
      if (error) throw error;
      const sample = data && data[0] ? Object.keys(data[0]) : [];
      sample.forEach(k => {
        if (/^class_\d{4}$/.test(k)) existingSessionCols.classes.add(k);
        if (/^section_\d{4}$/.test(k)) existingSessionCols.sections.add(k);
        if (/^roll_\d{4}$/.test(k)) existingSessionCols.rolls.add(k);
      });

      const years = new Set<string>();
      existingSessionCols.classes.forEach(c => { const m = c.match(/\d{4}$/); if (m) years.add(m[0]); });
      if (years.size) {
        sessionInfo.textContent = 'Detected session years: ' + Array.from(years).sort().join(', ');
      }
    } catch (e) {
      console.error('discoverSessionColumns failed', e);
      sessionInfo.textContent = 'Discovery error.';
    }
  }

  function getActiveKeys() {
    const ses = sessionFilter.value || '2025';
    const classKey = `class_${ses}`;
    const sectionKey = `section_${ses}`;
    const rollKey = `roll_${ses}`;
    const available = existingSessionCols.classes.has(classKey) && existingSessionCols.sections.has(sectionKey) && existingSessionCols.rolls.has(rollKey);
    return { session: ses, classKey, sectionKey, rollKey, available };
  }

  function buildSelectCols() {
    const base = ['iid', 'student_name_en', 'father_name_en', 'father_mobile', 'student_photo_url', 'status', 'session', 'fulldata_ok'];
    const sessions = ['2024', '2025', '2026', '2027'];
    sessions.forEach(s => {
      if (existingSessionCols.classes.has('class_' + s)) base.push('class_' + s);
      if (existingSessionCols.sections.has('section_' + s)) base.push('section_' + s);
      if (existingSessionCols.rolls.has('roll_' + s)) base.push('roll_' + s);
    });
    return base.join(', ');
  }

  // 2. Load all records
  async function loadData() {
    statusEl.textContent = 'Loading...';
    try {
      const batchSize = 1000;
      let allData: any[] = [];
      let lastId = 0;
      const { classKey, rollKey, available } = getActiveKeys();
      const orderField = (available && rollKey) ? rollKey : 'iid';

      while (true) {
        let q = sb.from(tableName)
          .select(buildSelectCols())
          .gt('iid', lastId)
          .order('iid', { ascending: true })
          .limit(batchSize);

        if (isSupabaseUser) {
          const selectedSchool = schoolFilter.value;
          if (selectedSchool) {
            q = q.eq('input_user_name', selectedSchool);
          }
        } else {
          q = q.eq('input_user_name', currentUser);
        }

        const { data, error } = await q;
        if (error) throw error;
        if (!data || data.length === 0) break;
        allData = allData.concat(data);
        lastId = (data[data.length - 1] as any).iid || lastId;
        if (data.length < batchSize) break;
      }

      // Filter by dynamic years
      if (classKey && allData.length) {
        allRowsCache = allData.filter(r => r && (r[classKey] !== undefined && r[classKey] !== null && String(r[classKey]).trim() !== ''));
      } else {
        allRowsCache = allData;
      }

      // Sort
      if (rollKey) {
        allRowsCache.sort((a, b) => (Number(a[rollKey]) || 0) - (Number(b[rollKey]) || 0));
      }

      // Rebuild filter lists
      populateClassFilters(allRowsCache);
      applyFilters();
    } catch (e: any) {
      console.error(e);
      tbody.innerHTML = `<tr><td colspan="13" style="color: #ff7b72;">Data load error: ${escapeHtml(e.message)}</td></tr>`;
      statusEl.textContent = 'Error';
    }
  }

  function populateClassFilters(rows: any[]) {
    const { classKey } = getActiveKeys();
    const classes = new Set<string>();
    rows.forEach(r => {
      if (r && r[classKey]) classes.add(String(r[classKey]));
    });

    const previousClass = classFilter.value;
    classFilter.innerHTML = '<option value="">All</option>' + Array.from(classes).sort((a,b) => Number(a)-Number(b)).map(c => `<option value="${c}">${c}</option>`).join('');
    
    if (previousClass && classes.has(previousClass)) {
      classFilter.value = previousClass;
    }
  }

  function populateSectionFilters(rows: any[]) {
    const { classKey, sectionKey } = getActiveKeys();
    const selClass = classFilter.value;
    const sections = new Set<string>();
    
    const rowsForSections = selClass ? rows.filter(r => String(r[classKey] || '') === String(selClass)) : rows;
    rowsForSections.forEach(r => {
      if (r && r[sectionKey]) sections.add(String(r[sectionKey]));
    });

    const previousSection = sectionFilter.value;
    sectionFilter.innerHTML = '<option value="">All</option>' + Array.from(sections).sort().map(s => `<option value="${s}">${s}</option>`).join('');
    
    if (previousSection && sections.has(previousSection)) {
      sectionFilter.value = previousSection;
    }
  }

  function applyFilters() {
    const c = classFilter.value;
    const s = sectionFilter.value;
    const { classKey, sectionKey } = getActiveKeys();

    let filtered = allRowsCache;
    if (c && classKey) {
      filtered = filtered.filter(r => String(r[classKey] || '') === c);
    }
    if (s && sectionKey) {
      filtered = filtered.filter(r => String(r[sectionKey] || '') === s);
    }

    renderTable(filtered);
    rowCountEl.textContent = `Total: ${filtered.length} records`;
    statusEl.textContent = 'Active';

    // Persist drop downs to localStorage
    try {
      localStorage.setItem('others_db_session', sessionFilter.value);
      localStorage.setItem('others_db_class', classFilter.value);
      localStorage.setItem('others_db_section', sectionFilter.value);
    } catch(e) {}
  }

  function renderTable(rows: any[]) {
    if (!rows || rows.length === 0) {
      tbody.innerHTML = '<tr><td colspan="13" style="text-align: center;">No records found</td></tr>';
      return;
    }

    tbody.innerHTML = '';
    const { classKey, sectionKey, rollKey } = getActiveKeys();

    rows.forEach((r, idx) => {
      const tr = document.createElement('tr');
      
      const sl = idx + 1;
      const iid = r.iid || '';
      const cls = r[classKey] || '';
      const sec = r[sectionKey] || '';
      const roll = r[rollKey] || '';
      const name = r.student_name_en || '';
      const fName = r.father_name_en || '';
      const fMobile = r.father_mobile || '';
      const photoUrl = r.student_photo_url || '';
      const session = r.session || '';
      const status = r.status || '';
      const fd = r.fulldata_ok || '';

      if (String(fd).toLowerCase() === 'ok') {
        tr.classList.add('row-fulldata-ok');
      } else if (String(status).toLowerCase().includes('tc')) {
        tr.classList.add('status-tc');
      }

      const isTC = String(status).toUpperCase() === 'TC' || String(status).toUpperCase().includes('TC');
      const statusStyle = isTC ? 'style="color: #ef4444; font-weight: bold;"' : '';

      tr.innerHTML = `
        <td class="col-sl">${sl}</td>
        <td>${escapeHtml(iid)}</td>
        <td>${escapeHtml(cls)}</td>
        <td>${escapeHtml(sec)}</td>
        <td>${escapeHtml(roll)}</td>
        <td>${escapeHtml(name)}</td>
        <td>${escapeHtml(fName)}</td>
        <td>${escapeHtml(fMobile)}</td>
        <td>
          ${photoUrl ? `<img class="row-thumb" src="${escapeHtml(photoUrl)}" alt="Photo"/>` : '<span style="color:#8b949e; font-size:11px;">No Photo</span>'}
        </td>
        <td>${escapeHtml(session)}</td>
        <td ${statusStyle}>${escapeHtml(status)}</td>
        <td>${escapeHtml(fd)}</td>
        <td class="action-cell">
          <a class="btn view" href="/other_school/view?iid=${encodeURIComponent(iid)}" target="_blank" onclick="window.open(this.href, '_blank'); return false;" style="background:#10b981; border-color:#10b981; color:#fff;">View</a>
          <a class="btn edit" href="/other_school/edit_details?iid=${encodeURIComponent(iid)}" target="_blank" onclick="window.open(this.href, '_blank'); return false;">Edit</a>
        </td>
      `;



      tbody.appendChild(tr);
    });
  }

  function openViewModal(record: any) {
    // Standard modular modal wrapper
    const modal = document.createElement('div');
    modal.style.cssText = 'position:fixed; inset:0; background:rgba(15, 23, 42, 0.3); backdrop-filter:blur(4px); display:flex; align-items:center; justify-content:center; z-index:10002; padding:20px;';
    
    modal.innerHTML = `
      <div style="background:#ffffff; border:1px solid rgba(0, 0, 0, 0.08); border-radius:16px; width:600px; max-width:100%; padding:24px; max-height:85vh; overflow-y:auto; box-shadow: 0 20px 50px rgba(15, 23, 42, 0.1);">
        <h3 style="margin-top:0; font-size:18px; color:#0f172a; display:flex; justify-content:space-between; align-items:center; border-bottom: 1px solid rgba(0, 0, 0, 0.08); padding-bottom: 14px;">
          <span>Student Full Details</span>
          <button id="closeModalBtn" style="background:transparent; border:none; color:#ef4444; font-size:24px; cursor:pointer; line-height:1;">&times;</button>
        </h3>
        <div style="display:flex; flex-direction:column; gap:2px; margin-top:16px;" id="fieldsList"></div>
      </div>
    `;

    const fieldsList = modal.querySelector('#fieldsList') as HTMLElement;
    Object.keys(record).sort().forEach(k => {
      const val = record[k] === null || record[k] === undefined ? '' : record[k];
      const row = document.createElement('div');
      row.style.cssText = 'display:grid; grid-template-columns:180px 1fr; border-bottom:1px solid rgba(0,0,0,0.05); padding:8px 0; font-size:13.5px;';
      row.innerHTML = `
        <span style="font-weight:700; color:#64748b; text-transform:uppercase; font-size:11px; letter-spacing:0.5px;">${escapeHtml(k)}:</span>
        <span style="color:#334155; font-weight:600; word-break:break-all;">${escapeHtml(val)}</span>
      `;
      fieldsList.appendChild(row);
    });

    const closeBtn = modal.querySelector('#closeModalBtn') as HTMLButtonElement;
    closeBtn.onclick = () => {
      document.body.removeChild(modal);
    };

    document.body.appendChild(modal);
  }

  // 3. Event listeners
  schoolFilter.onchange = async () => {
    classFilter.value = '';
    sectionFilter.value = '';
    await loadData();
  };

  sessionFilter.onchange = async () => {
    classFilter.value = '';
    sectionFilter.value = '';
    await loadData();
  };

  classFilter.onchange = () => {
    sectionFilter.value = '';
    populateSectionFilters(allRowsCache);
    applyFilters();
  };

  sectionFilter.onchange = () => {
    applyFilters();
  };

  refreshBtn.onclick = () => {
    loadData();
  };

  clearFilters.onclick = async () => {
    sessionFilter.value = '2025';
    classFilter.value = '';
    sectionFilter.value = '';
    if (isSupabaseUser) {
      schoolFilter.value = '';
    }
    await loadData();
  };

  // Discover and Initial Load
  await discoverSessionColumns();

  // Load schools if Super Admin
  if (isSupabaseUser) {
    try {
      const { data: buttonData, error: buttonErr } = await sb.from('button_status')
        .select('button_name, button_password, button_status')
        .order('button_name');
      if (!buttonErr && buttonData) {
        const filteredSchools = buttonData.filter(b => {
          if (!b || !b.button_name) return false;
          const pwd = String(b.button_password || '').trim();
          if (!pwd) return false;
          const status = String(b.button_status || '').toLowerCase();
          if (status.includes('disable') || status.includes('deactive')) return false;
          return true;
        });
        schoolFilter.innerHTML = '<option value="">All Schools</option>' + 
          filteredSchools.map(b => `<option value="${b.button_name}">${b.button_name}</option>`).join('');
      }
    } catch (e) {
      console.error('Failed to load school list', e);
    }
  }

  // Populate session years options dynamically
  const years = new Set<string>();
  existingSessionCols.classes.forEach(k => { const m = k.match(/\d{4}$/); if (m) years.add(m[0]); });
  const sortedYears = Array.from(years).sort();
  
  sessionFilter.innerHTML = sortedYears.map(y => `<option value="${y}">${y}</option>`).join('');

  // 4. Dropdown Restoration using localStorage
  try {
    const savedSession = localStorage.getItem('others_db_session');
    if (savedSession && sortedYears.includes(savedSession)) {
      sessionFilter.value = savedSession;
    } else if (sortedYears.includes('2025')) {
      sessionFilter.value = '2025';
    }
  } catch(e) {}

  await loadData();

  try {
    const savedClass = localStorage.getItem('others_db_class');
    if (savedClass && classFilter.querySelector(`option[value="${savedClass}"]`)) {
      classFilter.value = savedClass;
      populateSectionFilters(allRowsCache);
    }
    const savedSection = localStorage.getItem('others_db_section');
    if (savedSection && sectionFilter.querySelector(`option[value="${savedSection}"]`)) {
      sectionFilter.value = savedSection;
    }
    applyFilters();
  } catch(e) {}
}
